// reducers.js
import {FETCH_COLOR_LIST, SET_COLOR_LIST} from '../actions';

const initialState = {
    colorData: null,
    isLoading: false,
    error: null,
};

const colorListReducer = (state = initialState, action) => {


    switch (action.type) {

        // case SET_LOADING:
        //     return {
        //         ...state,
        //         isLoading: action.payload,
        //     };
        //
        // case SET_ERROR:
        //     return {
        //         ...state,
        //         error: action.payload,
        //     };

        case FETCH_COLOR_LIST:
            return {
                ...state,
            };

        case SET_COLOR_LIST:
            return {
                ...state,
                colorData: action.payload,
                isLoading: false,
            };


        default:
            return state;
    }
};

export default colorListReducer;
